import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import DonutChart from "../charts/donut_chart/view/DonutChart";
import SmallTable from "../charts/small_table/view/SmallTable";
import { useState } from "react";
const DonutTable = ({
    tableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        },
    ],
    tableData = [
        {
            key: '1',
            name: 'Mike',
            age: 32,
            address: '10 Downing Street',
        },
        {
            key: '2',
            name: 'John',
            age: 42,
            address: '10 Downing Street',
        },
    ],
    DonutDataKey = "value",
    DonutData = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
        { name: 'Group C', value: 300 },
        { name: 'Group D', value: 200 },
        { name: 'Group E', value: 200 },
        { name: 'Group F', value: 200 },
    ]

}) => {
    return (
        <Row gutter={[8, 8]}>
            <Col span={24} >
                <div
                    style={{
                        height: "180px"
                    }}
                >
                    <DonutChart
                        dataKey={DonutDataKey ?? "value"}
                        data={DonutData}
                    />
                </div>
            </Col>
            <Col span={24} >
                <SmallTable
                    columns={tableColumns}
                    dataSource={tableData}
                />
            </Col>
        </Row>
    )
}

export { DonutTable }